import React from 'react';
import DynamicComponent from '~/components/DynamicComponent';
import SbEditable from 'storyblok-react';

const Grid = ({ blok }) => {

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div purgeclassname="md:grid-cols-2 lg:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-12 gap-16 gap-20 gap-24" />
      <ul className={`grid ${blok.gap} ${blok.width}`}>
        {blok.items.map((blok) => (
          <li key={blok._uid} className="flex-auto">
            <DynamicComponent blok={blok} />
          </li>
        ))}
      </ul>
    </SbEditable>
  )
};

export default Grid;
